import { toStartOfDay } from '../../utils/dates';

export const combineDateStartTimestampWithMinute = (
    dateTimestamp?: number,
    minute?: number
): number | undefined => {
    if (!Number.isInteger(dateTimestamp) || !Number.isInteger(minute)) {
        return undefined;
    }

    const startOfDayTimestamp = toStartOfDay(dateTimestamp);
    const minuteInMiliseconds = minute * 1000 * 60;
    const combinedTimestamp = startOfDayTimestamp + minuteInMiliseconds;

    return combinedTimestamp;
};
